import React, { useCallback, useEffect } from 'react'
import deepEqual from 'react-fast-compare'

import Acp from 'syft-acp-uikit'
import { fetchPointTransactions } from 'syft-acp-core/actions/point-transactions'
import { createEntityListConnector } from 'syft-acp-util/entityList'
import usePrevValue from 'syft-acp-util/hooks/usePrevValue'

export const entityConnector = createEntityListConnector({
  entityActions: {
    fetchEntities: ({ options }, { workerID }) => fetchPointTransactions(workerID, options),
  },
  entityStore: 'pointTransactions',
})

const WorkerPointTransactionsList = ({ actions, data, isLoadingData, query, workerID }: any) => {
  const prevQuery = usePrevValue(query)
  const prevWorkerID = usePrevValue(workerID)

  const fetch = useCallback(
    q => actions.fetchEntities && workerID && actions.fetchEntities({ options: q }, { workerID }),
    [actions, workerID],
  )

  useEffect(() => {
    if (!deepEqual(prevQuery, query)) fetch(query)
  }, [fetch, prevQuery, query])

  useEffect(() => {
    if (prevWorkerID !== workerID) fetch(query)
  }, [fetch, prevWorkerID, workerID, query])

  return (
    <Acp.EntityList data={data} isLoading={isLoadingData} idKeyValue="id" isIntegrated={true} hasPagination>
      <Acp.Table>
        <Acp.Col.Text value="id" header="ID" align="left" isMinimal />
        <Acp.Col.Text value="shift_id" header="Shift ID" align="left" isMinimal />
        <Acp.Col.Text value="job_id" header="Job ID" align="left" isMinimal />
        <Acp.Col.Text value="event_name" header="Action" align="left" isMinimal />
        <Acp.Col.Text value="points" header="Points" align="left" isMinimal />
        <Acp.Col.Text value="total_after_apply" header="Total Points" align="left" isMinimal />
        <Acp.Col.Text
          value={(rowData: any) => rowData.status_tier?.name || 'N/A'}
          header="Tier Level"
          align="left"
          isMinimal
        />
        <Acp.Col.DateTime value="created_at" header="Created At" align="left" isMinimal />
      </Acp.Table>
    </Acp.EntityList>
  )
}

export default entityConnector(WorkerPointTransactionsList)
